export default function gallery() {

    var mainCarousel = $('.main-slider');
    var navigationCarousel = $('.second-slider');

    mainCarousel.each(function () {
        const self = $(this);

        self.slick({
            dots: true,
            arrows: true,
            prevArrow: '<div class="slick-prev"><i class="fal fa-chevron-left"></i></div>',
            nextArrow: '<div class="slick-next"><i class="fal fa-chevron-right"></i></div>',
            infinite: true,
            speed: 500,
            slide: 'div',
            cssEase: 'linear',
            asNavFor: self.closest('.realty-slider').find('.second-slider'),
            fade: true,
        });
    });

    navigationCarousel.each(function () {
        const self = $(this);

        self.slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 500,
            slide: 'div',
            cssEase: 'linear',
            asNavFor: self.closest('.realty-slider').find('.main-slider'),
            slidesToShow: 3,
            focusOnSelect: true,
        });
    });
}


// WEBPACK FOOTER //
// ./scripts/modules/gallery.js